import React from 'react';
import { Link } from 'react-router-dom';
import './sidebar.css';
import { FaUser, FaUserEdit, FaUsers, FaClock, FaHeart, FaEye, FaSearch, FaShoppingCart, FaStar } from 'react-icons/fa';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <Link to="/dashboard" className="sidebar-item">
        <FaUser />
        My profile
      </Link>
      <Link to="/edit-profiles" className="sidebar-item">
        <FaUserEdit />
        Edit Profile
      </Link>
      <Link to="/search" className="sidebar-item">
        <FaSearch />
        Search
      </Link>
      <Link to="/all-profiles" className="sidebar-item">
        <FaUsers />
        All Profiles
      </Link>
      <Link to="/recent-profiles" className="sidebar-item">
        <FaClock />
        Recent Profiles
      </Link>
      <Link to="/interested-profiles" className="sidebar-item">
        <FaHeart />
        Interested Profiles
      </Link>
      <Link to="/viewed-profiles" className="sidebar-item">
        <FaEye />
        Viewed Profiles
      </Link>
      <Link to="/viewed-my-profiles" className="sidebar-item">
        <FaEye />
        Viewed My Profiles
      </Link>
      <Link to="/shortlisted-profiles" className="sidebar-item">
        <FaStar />
        Shortlisted Profiles
      </Link>
      
      <Link to="/purchased-profiles" className="sidebar-item">
        <FaShoppingCart />
        Purchased Profile
      </Link>
    </div>
  );
};

export default Sidebar;

